module.exports = {
  title: '索赔订单',
  route: {
    path: '/admin-order-manage',
    children: {
      path: 'order-claim-indemnity',
    },
  },
};
